import { useCallback, useContext } from 'react';
import { Linking } from 'react-native';
import { useAuthStateStore } from '@annunciate/core';
import { selectPurchaseUrl } from '@annunciate/core/dist/utils/purchase';
import { Oidc } from '@annunciate/web/dist/context';
import { mergeSearchParams } from '../utils';
export const useOnPurchaseHandler = () => {
    const { uuid, email } = useAuthStateStore((state => {
        return {
            uuid: state.uuid,
            email: state.jwt?.email,
        };
    }));
    const ctx = useContext(Oidc);
    const handler = useCallback((purchaseable, postPurchaseRedirect = window.location.pathname) => {
        const { allowPurchaseWithoutAuthentication, purchaseUrl, } = selectPurchaseUrl(purchaseable);
        if (purchaseUrl) {
            let redirectUri = mergeSearchParams({
                from: window.location.search,
                into: purchaseUrl,
            });
            window.localStorage.setItem('purchase/finalize', postPurchaseRedirect);
            if (uuid) {
                const redirect = new URL(redirectUri);
                redirect.searchParams.append('client_reference_id', uuid);
                if (email) {
                    redirect.searchParams.append('prefilled_email', email);
                }
                Linking.openURL(redirect.toString(), '_self');
            }
            else if (allowPurchaseWithoutAuthentication) {
                Linking.openURL(redirectUri, '_self');
            }
            else {
                const redirect = new URL(`${window.location.origin}/purchase`);
                redirect.searchParams.append('purchase_redirect_uri', redirectUri);
                if (ctx.register) {
                    ctx.register(redirect.toString());
                }
                else {
                    ctx.signIn(redirect.toString());
                }
            }
        }
    }, [uuid, ctx, email]);
    return handler;
};
//# sourceMappingURL=useOnPurchaseHandler.js.map